export interface RecoveryState {
  isLoading: boolean
  credentials: Credentials
  currentStep:
    | 'SEND_EMAIL'
    | 'VERIFY_CODE'
    | 'REESTABLISH_PASSWORD'
    | 'PASSWORD_SUCCESSFUL'
}

export type RecoveryStep = RecoveryState['currentStep']
export type Credentials = {
  email: string
  password: string
  securityCode: string
}

export const initialState: RecoveryState = {
  currentStep: 'SEND_EMAIL',
  isLoading: false,
  credentials: {
    email: '',
    password: '',
    securityCode: ''
  }
}
